import { render, staticRenderFns } from "./StudentPolicies.vue?vue&type=template&id=760d2851&"
import script from "./StudentPolicies.vue?vue&type=script&lang=js&"
export * from "./StudentPolicies.vue?vue&type=script&lang=js&"
import style0 from "./StudentPolicies.vue?vue&type=style&index=0&id=760d2851&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports